import MaterialItemsService from "@/services/MaterialItemsService";
import { validateRestrictionData } from "@/utils/helpers";

export default {
    state() {
        return {
            materialItem: {
                id: "",
                title: "",
                description: "",
                type: "",
                file: "",
                materialId: "",
                iframeCode: "",
                visible: "",
                quizzes: "",
                settings: "",
                isEditable: ""
            },
            materialItemData: {
                data: ""
            },
            materialsRelatedToDiscipline: [],
            materialItemsData: [],
            materialItemsAnswers: {},
            personalAttempts: {},
            materialDataToUpdate: null,
            materialTypeToUpdate: null,
            requestingMaterials: false,
            iframeCodeToRender: null,
            lastRouteBeforeAssigmentFeedback: null,
        }
    },

    getters: {
        getPersonalAttemptAssigment: (state) => state.personalAttempts[0],
        getLastRouteBeforeAssigmentFeedback: (state) => state.lastRouteBeforeAssigmentFeedback,
        getIframeCode: (state) => state.iframeCodeToRender,
        getRequestingMaterialsState: (state) => state.requestingMaterials,
        getMaterialsRelatedToDiscipline: (state) => state.materialsRelatedToDiscipline,
        getMaterialDataToUpdate: (state) => state.materialDataToUpdate,
        getMaterialTypeToUpdate: (state) => state.materialTypeToUpdate,
        getMaterialItemsData: (state) => state.materialItemsData,
        getMaterialItem: (state) => state.materialItem,
        getMaterialItemTitle: (state) => state.materialItem.title,
        getMaterialItemDescription: (state) => state.materialItem.description,
        getMaterialItemType: (state) => state.materialItem.type,
        getMaterialItemFile: (state) => state.materialItem.file,
        getMaterialItemMaterialId: (state) => state.materialItem.materialId,
        getMaterialItemIframeCode: (state) => state.material.iframeCode,
        getMaterialItemVisible: (state) => state.material.visible,
        getMaterialItemData: (state) => state.materialItemData.data,
        getMaterialItemAnswers: (state) => state.materialItemsAnswers
    },

    mutations: {
        setMaterialItemsDataBasedInIndexes(state, data) {
            data && (state.materialItemsData = data)
        },

        updateAttemptFinishedAt(state, data) {
            const attemptIndex = state.materialItemsAnswers.findIndex((attempt) => attempt.id === data.attemptId)
            if (attemptIndex !== -1) {
                state.materialItemsAnswers[attemptIndex].finished_at = data.finished_at
            }
        },

        deleteMaterialItemAnswer(state, data) {
            const attemptIndex = state.materialItemsAnswers.findIndex((attempt) => attempt.id === data)
            if (attemptIndex !== -1) {
                state.materialItemsAnswers.splice(attemptIndex, 1)
            }
        },

        setLastRouteBeforeAssigmentFeedback(state, data) {
            state.lastRouteBeforeAssigmentFeedback = data || null
        },

        setIframeCodeToRender(state, data) {
            data && (state.iframeCodeToRender = data)
        },

        resetMaterialItensData(state) {
            state.materialItemsData = []
        },

        setRequestingMaterialsState(state, data) {
            state.requestingMaterials = data
        },

        setMaterialsRelatedToDiscipline(state, data) {
            data && (state.materialsRelatedToDiscipline = data)
        },

        setMaterialDataToUpdate(state, data) {
            state.materialDataToUpdate = data || null
        },

        setMaterialTypeToUpdate(state, data) {
            state.materialTypeToUpdate = data || null
        },

        setErrorDataWhenUploadingZip(state, data) {
            !data && (state.errorDataWhenUploadingZip = null)
            state.errorDataWhenUploadingZip = data
        },

        setMaterialItemData(state, data) {
            data && (state.materialItem = data)
        },
        resetMaterialItem(state) {
            state.material = {
                title: "",
                description: "",
                type: "",
                file: "",
                materialId: "",
                iframeCode: "",
                visible: ""
            };
        },
        setMaterialItemsData(state, data) {
            state.materialItemsData = data || []
        },
        createMaterialItem(state, data) {
            if (data instanceof Array) {
                state.materialItemsData.push(data[0])

                state.materialDataToUpdate = null
                state.materialTypeToUpdate = null
                return
            }
            state.materialItemsData.push(data)

            state.materialDataToUpdate = null
            state.materialTypeToUpdate = null
        },

        insertMaterialItemsByFile(state, data) {
            data.length > 0 && (state.materialItemsData = [...state.materialItemsData, ...data])
        },

        updateMaterialItemProgress(state, data) {
            const materialItemIndex = state.materialItemsData.findIndex((m) => m.id === data.materialItemId)
            const materialItemIndexInRelatedToDiscipline = state.materialsRelatedToDiscipline.findIndex((m) => m.id === data.materialItemId)
            materialItemIndex !== -1 && (state.materialItemsData[materialItemIndex].checked = data.check)
            materialItemIndexInRelatedToDiscipline !== -1 && (state.materialsRelatedToDiscipline[materialItemIndexInRelatedToDiscipline].checked = data.check)
        },

        updateMaterialItem(state, data) {
            const index = state.materialItemsData.findIndex((m) => m.id === data.id)
            index !== -1 && (state.materialItemsData[index] = data)
            state.materialItem && (state.materialItem = data)
            state.materialDataToUpdate = null
            state.materialTypeToUpdate = null
        },

        duplicateMaterialItem(state, data) {
            state.materialItemsData.splice(data.index, 0, data)
        },

        deleteMaterialItem(state, data) {
            const materialIndex = state.materialItemsData.findIndex((m) => m.id == data)
            materialIndex !== -1 && (state.materialItemsData.splice(materialIndex, 1))
        },

        setMaterialItemsAnswers(state, data) {
            state.materialItemsAnswers = data;
        },
        personalAttempts(state, data) {
            state.personalAttempts = data;
        },

        updateMaterialItemSettings(state, data) {
            data && (state.materialItem.settings = data)
        },

        removeMaterialItemRestrictionToConsumers(state, data) {
            const { validPayload, contentManipulatedId, consumersId } = validateRestrictionData(data)
            if (!validPayload) return

            const materialItemIndex = state.materialItemsData.findIndex((materialItem) => materialItem?.id === contentManipulatedId)
            if (materialItemIndex !== -1) {
                const materialItem = state.materialItemsData[materialItemIndex]

                materialItem.restricted_consumers = materialItem.restricted_consumers.filter((consumerId) => !consumersId.includes(consumerId))
            }
        },

        restrictMaterialItemToConsumers(state, data) {
            const { validPayload, contentManipulatedId, consumersId } = validateRestrictionData(data)
            if (!validPayload) return

            const materialItemIndex = state.materialItemsData.findIndex((materialItem) => materialItem?.id === contentManipulatedId)
            if (materialItemIndex !== -1) {
                const materialItem = state.materialItemsData[materialItemIndex]
                !materialItem.restricted_consumers && (materialItem.restricted_consumers = [])

                const newConsumers = consumersId.filter(id => !materialItem.restricted_consumers.includes(id))
                materialItem.restricted_consumers = [
                    ...materialItem.restricted_consumers,
                    ...newConsumers
                ]
            }
        }
    },

    actions: {
        setMaterialItemsDataBasedInIndexes({ commit }, payload) {
            commit('setMaterialItemsDataBasedInIndexes', payload)
        },

        updateAttemptFinishedAt({ commit }, payload) {
            commit('updateAttemptFinishedAt', payload)
        },

        deleteMaterialItemAnswer({ commit }, payload) {
            commit('deleteMaterialItemAnswer', payload)
        },

        setLastRouteBeforeAssigmentFeedback({ commit }, payload) {
            commit('setLastRouteBeforeAssigmentFeedback', payload)
        },

        setIframeCodeToRender({ commit }, payload) {
            commit('setIframeCodeToRender', payload)
        },

        resetMaterialItensData({ commit }) {
            commit('resetMaterialItensData')
        },

        setMaterialTypeToUpdate({ commit }, payload) {
            commit('setMaterialTypeToUpdate', payload)
        },

        setMaterialDataToUpdate({ commit }, payload) {
            commit('setMaterialDataToUpdate', payload)
        },

        async moveMateriaItem({ commit, dispatch }, payload) {
            try {
                await MaterialItemsService.moveMaterialItem(payload)
                await commit('deleteMaterialItem', payload?.materialItemId)
                dispatch('toastfy/activeSuccesNotification', { text: 'Item de material transferido com sucesso!' })
                return true
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
                return false
            }
        },

        async getMaterialsRelatedToDiscipline({ commit, dispatch }, payload) {
            try {
                const response = await MaterialItemsService.getMaterialItems(payload.data, payload.userToken)
                commit('setMaterialsRelatedToDiscipline', response.data)
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            }
        },

        async changeMaterialItemStatus({ commit, dispatch }, payload) {
            try {
                const response = await MaterialItemsService.changeMaterialItemStatus(payload)
                commit('updateMaterialItemProgress', payload.requestData)
                dispatch('updateMaterialProgress', { materialId: response.material_item.material_id, material_progress: response.material_progress })
                dispatch('updateDisciplineProgress', response.discipline_progress)

                dispatch('toastfy/activeSuccesNotification', { text: response.message })
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            }
        },

        async createMaterialItem({ commit, dispatch }, payload) {
            try {
                dispatch('clearModalData')
                dispatch('setLoadingState', { loadignState: true, loadingView: 'materialsView' }, { root: true });
                const response = await MaterialItemsService.createMaterialItem(payload.materialItem, payload.userToken);
                commit('createMaterialItem', response.data)
                dispatch('toastfy/activeSuccesNotification', { text: 'Item de material criado com sucesso!' })
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error.response.data.message })
            } finally {
                dispatch('setLoadingState', { loadignState: false })
            }
        },

        async findMaterialItem({ commit }, payload) {
            try {
                const response = await MaterialItemsService.findMaterialItem(payload.materialItemId, payload.userToken);
                commit('setMaterialItemData', response.data);

                return response.data;
            } catch {
                dispatch('toastfy/activeErrorNotification', { text: `Erro ao encontrar item de material, tente novamente!` })
            }
        },

        async updateMaterialItem({ commit, dispatch }, payload) {
            try {
                dispatch('setLoadingState', { loadignState: true, loadingView: 'materialsView' }, { root: true });
                const response = await MaterialItemsService.updateMaterialItem(payload.materialItem, payload.userToken);
                commit('updateMaterialItem', response.data)
                dispatch('toastfy/activeSuccesNotification', { text: 'Item de material atualizado com sucesso!' })
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error.response.data.message })
            } finally {
                dispatch('setLoadingState', { loadignState: false })
            }
        },

        async deleteMaterialItem({ commit, dispatch }, payload) {
            try {
                dispatch('setLoadingState', { loadignState: true, loadingView: 'materialsView' }, { root: true });
                const response = await MaterialItemsService.deleteMaterialItem(payload.materialItemId, payload.userToken);
                commit('deleteMaterialItem', payload.materialItemId)
                dispatch('toastfy/activeSuccesNotification', { text: 'Item de material deletado com sucesso!' })
            } catch {
                dispatch('toastfy/activeErrorNotification', { text: `Erro ao deletar item de material, tente novamente!` })
            } finally {
                dispatch('setLoadingState', { loadignState: false })
            }
        },

        updateMaterialItemsPosition({ commit }, payload) {
            commit('setMaterialItemsData', payload)
        },

        async getMaterialItems({ commit, dispatch }, payload) {
            try {
                commit('setRequestingMaterialsState', true)
                const response = await MaterialItemsService.getMaterialItems(payload.data, payload.userToken);

                commit('setMaterialItemsData', response.data);

                return response.data;
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: `Erro ao consultar itens de material, tente novamente!` })
            } finally {
                commit('skeleton/setLoadingState', { key: 'materialsDisciplineMaterialItems', value: false })
                commit('setRequestingMaterialsState', false)
            }
        },

        async duplicateMaterialItem({ commit, dispatch }, payload) {
            try {
                dispatch('setLoadingState', { loadignState: true, loadingView: 'materialsView' }, { root: true });
                const response = await MaterialItemsService.duplicateMaterialItem(payload.materialItemId, payload.userToken);

                commit('duplicateMaterialItem', response.data)
                commit('setMaterialItemData', response.data);
                dispatch('toastfy/activeSuccesNotification', { text: 'Item de material duplicado com sucesso!' })

                return response.data;
            } catch {
                dispatch('toastfy/activeErrorNotification', { text: `Erro ao duplicar item de material, tente novamente!` })
            } finally {
                dispatch('setLoadingState', { loadignState: false })
            }
        },

        async removeQuiz({ commit }, payload) {
            try {
                const response = await MaterialItemsService.removeQuiz(payload.data, payload.userToken);

                commit('resetMaterialItem');

                return response.data;
            } catch (error) {
                console.error('Erro ao remover questão:', error);

                throw error;
            }
        },

        async updateQuestionWeights({ commit }, payload) {
            try {
                const response = await MaterialItemsService.updateQuestionnaireWeights(
                    {
                        materialItemId: payload.materialItemId,
                        weights: payload.weights,
                        gradesByWeightEnabled: payload.gradesByWeightEnabled ?? false
                    }, 
                    payload.userToken
                );

                return response.data;
            } catch (error) {
                console.error('Erro ao atualizar pesos das questões:', error);
                throw error;
            }
        },

        async getPersonalAttempts({ commit }, payload) {
            try {
                const response = await MaterialItemsService.getAttempts(payload, payload.userToken);

                commit('personalAttempts', response.data);
            } catch (error) {
                console.error('Erro ao consultar tentativas:', error);

                throw error;
            }
        },

        async getAttempts({ commit, dispatch }, payload) {
            try {
                const response = await MaterialItemsService.getAttempts(payload, payload.userToken);

                commit('setMaterialItemsAnswers', response.data);
            } catch (error) {
                console.error('Erro ao consultar tentativas:', error);

                throw error;
            } finally {
                if (payload.skeletonKey) {
                    dispatch('skeleton/setLoadingState', { key: payload.skeletonKey, value: false }, { root: true })
                }
            }
        },

        async updateMaterialItemIndex({ commit, dispatch }, payload) {
            try {

                const response = await MaterialItemsService.updateIndex(payload.data, payload.userToken);
                return response.data;
            } catch (error) {
                console.error('Erro ao atualizar índice:', error);

                throw error;
            }
        },

        async downloadMaterialItemFile({ commit, dispatch }, payload) {
            try {
                dispatch('setLoadingState', { loadignState: true, loadingView: 'materialsView' }, { root: true });
                dispatch('toastfy/activeSuccesNotification', { text: "Iniciando Download do Arquivo!" })
                const response = await MaterialItemsService.downloadMaterialItemFile(payload)
                return response
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            } finally {
                dispatch('setLoadingState', { loadignState: false }, { root: true });
            }
        },

        async uploadMaterialItemFile({ commit, dispatch }, payload) {
            try {
                dispatch('setLoadingState', { loadignState: true, loadingView: 'materialsView' }, { root: true });
                dispatch('toastfy/activeSuccesNotification', { text: "Iniciando Validação de Arquivos!" })
                const response = await MaterialItemsService.uploadMaterialItemFile(payload.data, payload.userToken);
                commit('insertMaterialItemsByFile', response?.material_items || [])

                if (response?.material_items.length > 0) {
                    dispatch('toastfy/activeSuccesNotification', {
                        text: response.errors.length === 0 ?
                            "Arquivos Inseridos com Sucesso!"
                            : "Alguns dos arquivos foram inseridos"
                    })
                }

                if (response.errors.length > 0) {
                    dispatch('toastfy/activeErrorNotification', { text: "Os titulos dos arquivos podem contem no máximo 50 caracteres", customTimeLimit: 20000 })
                    response.errors.forEach((error) => {
                        dispatch('toastfy/activeErrorNotification', { text: `Arquivo Invalido: ${error.file}`, customTimeLimit: 20000 })
                    })
                }
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error.response.data.message || "Ocorreu um erro ao inserir materiais! Tente novamente" })
            } finally {
                dispatch('setLoadingState', { loadignState: false }, { root: true });
            }
        },

        async createMaterialItemSettings({ commit, dispatch }, payload) {
            try {
                dispatch('setLoadingState', { loadignState: true, loadingView: 'Assigments Management' })
                const response = await MaterialItemsService.createMaterialItemSettings(payload)
                dispatch('toastfy/activeSuccesNotification', { text: "Configurações Salvas com Sucesso!" })
                commit('updateMaterialItemSettings', response.data)
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            } finally {
                dispatch('setLoadingState', { loadignState: false }, { root: true });
            }
        },

        async updateMaterialItemSettings({ commit, dispatch }, payload) {
            try {
                dispatch('setLoadingState', { loadignState: true, loadingView: 'Assigments Management' })
                const response = await MaterialItemsService.updateMaterialItemSettings(payload)
                dispatch('toastfy/activeSuccesNotification', { text: "Configurações Atualizadas com Sucesso!" })
                commit('updateMaterialItemSettings', response.data)
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            } finally {
                dispatch('setLoadingState', { loadignState: false }, { root: true });
            }
        },

        async validateMaterialItemPassword({ commit, dispatch }, payload) {
            try {
                dispatch('setLoadingState', { loadignState: true, loadingView: 'Assigments Management' })
                await MaterialItemsService.validateMaterialItemPassword(payload)
                return true
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
                return false
            } finally {
                dispatch('setLoadingState', { loadignState: false }, { root: true });
            }
        },

        async createAssigmentAnswer({ commit, dispatch }, payload) {
            try {
                dispatch('setLoadingState', { loadignState: true, loadingView: 'Assigments Management' }, { root: true })
                dispatch('toastfy/setToastDataToDispatchBetweenRoutes', { type: 'success', message: "Resposta Registrada com Sucesso!" })
                return await MaterialItemsService.createAssigmentAnswer(payload)
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error }, { root: true })
            } finally {
                dispatch('setLoadingState', { loadignState: false }, { root: true });
            }
        },

        async evaluateAssigment({ commit, dispatch }, payload) {
            try {
                const response = await MaterialItemsService.evaluateAssigment(payload)
                dispatch('toastfy/setToastDataToDispatchBetweenRoutes', { type: 'success', message: "Avaliação Registrada com Sucesso!" })
                return response
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            }
        },

        async downloadMaterialItemFileWatermark({ commit, dispatch }, payload) {
            if (!payload) return

            try {
                dispatch('setLoadingState', { loadignState: true, loadingView: 'Assigments Management' }, { root: true })
                const response = await MaterialItemsService.downloadMaterialItemFileWaterMark(payload)
                const fileWatermark = response?.url

                if (!fileWatermark) {
                    dispatch('toastfy/activeSuccesNotification', { text: response?.message || "O material está sendo processado! Aguarde" })
                    return
                }

                return fileWatermark
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            } finally {
                dispatch('setLoadingState', { loadignState: false }, { root: true });
            }
        },

        async initializeExternalTool({ commit, dispatch }, payload) {
            try {
                dispatch('setLoadingState', { loadignState: true, loadingView: 'Assigments Management' }, { root: true })
                const response = await MaterialItemsService.initializeExternalTool(payload)
                return response
            } catch (error) {
                console.log("Error")
                dispatch('toastfy/activeErrorNotification', { text: error })
            } finally {
                dispatch('setLoadingState', { loadignState: false }, { root: true });
            }
        },

        async validateExternalToolURL({}, payload) {
            try {
                const response = await MaterialItemsService.validateExternalToolURL(payload)
                return { ltiTool: response?.lti_tool || {} }
            } catch (error) {
                return { ltiTool: null }
            }
        },

        async restrictMaterialItemToConsumers({ commit, dispatch }, payload) {
            try {
                await MaterialItemsService.restrictMaterialItemToConsumers(payload)
                commit('restrictMaterialItemToConsumers', payload)
                dispatch('toastfy/activeSuccesNotification', { text: "Restrição aplicada a consumidores com sucesso!" })
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            }
        },

        async removeMaterialItemRestrictionToConsumers({ commit, dispatch }, payload) {
            try {
                await MaterialItemsService.removeMaterialItemRestrictionToConsumers(payload)
                commit('removeMaterialItemRestrictionToConsumers', payload)
                dispatch('toastfy/activeSuccesNotification', { text: "Restrição removida a consumidores com sucesso!" })
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            }
        },
    }
}
